var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "expandable-content-button" },
    [
      _c(
        "button",
        {
          class: _vm.styles,
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.showContent = !_vm.showContent
            }
          }
        },
        [
          _c("i", { class: _vm.showContent ? _vm.hideIcon : _vm.icon }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.showContent ? _vm.hideText : _vm.text))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showContent ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a23eb7d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a23eb7d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/ExpandableContentButton.vue
// module id = 238
// module chunks = 0